import Vue from 'vue'
import Vuex from 'vuex'
import I18n from '@/lang'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    mobileDevice: false,
    lang: 'zh'
  },
  mutations: {
    set_mobileDevice(state, value) {
      state.mobileDevice = value
    },
    set_lang(state, value) {
      I18n.lang(value)
      state.lang = value
    }
  }
  // modules: {
  //  logonStatus,
  // }
})
